module.exports = __webpack_public_path__ + "img/payangel_logo_w.8eb0df5a.png";